export default __webpack_public_path__ + "static/media/yoshinani_logo.f17971a7.svg";